(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335,5096,3264],{

/***/ 36981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Button = function Button(_ref) {
  var icondown = _ref.icondown,
      onSubmit = _ref.onSubmit,
      text = _ref.text,
      src = _ref.src,
      img = _ref.img,
      hoverImg = _ref.hoverImg,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      color = _ref.color,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      margin = _ref.margin,
      background = _ref.background,
      borderRadius = _ref.borderRadius,
      border = _ref.border,
      width = _ref.width,
      height = _ref.height,
      hoverBackground = _ref.hoverBackground,
      target = _ref.target,
      borderColor = _ref.borderColor,
      hoverColor = _ref.hoverColor,
      icon = _ref.icon,
      padding = _ref.padding,
      newtablink = _ref.newtablink,
      iconvideo = _ref.iconvideo;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledBtn, {
    className: "dc-btn fade-up",
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    background: background,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing,
    margin: margin,
    border: border,
    img: img,
    borderRadius: borderRadius,
    width: width,
    hoverImg: hoverImg,
    hoverBackground: hoverBackground,
    height: height,
    borderColor: borderColor,
    target: target,
    hoverColor: hoverColor,
    onSubmit: onSubmit,
    padding: padding,
    children: // ok
    src ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: src || '/',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
          children: text
        })
      })
    }) : newtablink ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: newtablink || '/',
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
          children: ["  ", icon ? icondown ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "19",
            height: "20",
            viewBox: "0 0 19 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "download",
              transform: "translate(-3.637 -3)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8769",
                "data-name": "Path 8769",
                d: "M4.692,16a1.054,1.054,0,0,1,1.056,1.053v2.105a1.051,1.051,0,0,0,.309.744h0a1.057,1.057,0,0,0,.746.308H19.47a1.054,1.054,0,0,0,1.056-1.053V17.053a1.056,1.056,0,0,1,2.111,0v2.105a3.162,3.162,0,0,1-3.167,3.158H6.8a3.162,3.162,0,0,1-3.167-3.158V17.053A1.054,1.054,0,0,1,4.692,16Z",
                transform: "translate(0 0.684)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8770",
                "data-name": "Path 8770",
                d: "M6.946,10.308a1.058,1.058,0,0,1,1.493,0l4.531,4.519L17.5,10.308A1.054,1.054,0,0,1,18.994,11.8L13.716,17.06a1.058,1.058,0,0,1-1.493,0L6.946,11.8A1.051,1.051,0,0,1,6.946,10.308Z",
                transform: "translate(0.167 0.368)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8771",
                "data-name": "Path 8771",
                d: "M12.692,3a1.054,1.054,0,0,1,1.056,1.053V16.684a1.056,1.056,0,0,1-2.111,0V4.053A1.054,1.054,0,0,1,12.692,3Z",
                transform: "translate(0.444)",
                fill: "#fff",
                fillRule: "evenodd"
              })]
            })
          }) : iconvideo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20.003",
            height: "20",
            viewBox: "0 0 20.003 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_19478",
              "data-name": "Group 19478",
              transform: "translate(-158 -480)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8772",
                "data-name": "Path 8772",
                d: "M19.558,25.667H17a2.318,2.318,0,0,0-4.449,0H1.667a.667.667,0,0,0,0,1.334H12.555A2.318,2.318,0,0,0,17,27h2.554a.667.667,0,0,0,0-1.334ZM14.78,27.333a1,1,0,1,1,1-1A1,1,0,0,1,14.78,27.333Z",
                transform: "translate(157 471.336)"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8773",
                "data-name": "Path 8773",
                d: "M18.909,1H3.094A2.1,2.1,0,0,0,1,3.094V13.575a2.1,2.1,0,0,0,2.094,2.094H18.909A2.1,2.1,0,0,0,21,13.575V3.094A2.1,2.1,0,0,0,18.909,1Zm.76,12.575a.761.761,0,0,1-.76.76H3.094a.761.761,0,0,1-.76-.76V3.094a.761.761,0,0,1,.76-.76H18.909a.761.761,0,0,1,.76.76Z",
                transform: "translate(157 479)"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8774",
                "data-name": "Path 8774",
                d: "M18.354,9.435,13.02,6.1A.667.667,0,0,0,12,6.667v6.668a.667.667,0,0,0,1.02.565l5.334-3.334a.667.667,0,0,0,0-1.133Zm-5.021,2.7V7.867L16.743,10Z",
                transform: "translate(153.334 477.334)"
              })]
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "login_2",
              "data-name": "login 2",
              transform: "translate(-3.25)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8718",
                "data-name": "Path 8718",
                d: "M12.107,3.25a.857.857,0,1,0,0,1.714,8.286,8.286,0,0,1,0,16.571.857.857,0,1,0,0,1.714,10,10,0,0,0,0-20Z",
                transform: "translate(1.143 -3.25)",
                fill: "#fff"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8719",
                "data-name": "Path 8719",
                d: "M11.5,9.713A.857.857,0,1,1,12.713,8.5l3.429,3.429a.857.857,0,0,1,0,1.212L12.713,16.57A.857.857,0,1,1,11.5,15.358l1.965-1.965H4.107a.857.857,0,0,1,0-1.714h9.359Z",
                transform: "translate(0 -2.536)",
                fill: "#fff"
              })]
            })
          }) : '', text]
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: 'javascript:void(0)',
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
          children: ["  ", icon ? icondown ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "19",
            height: "20",
            viewBox: "0 0 19 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "download",
              transform: "translate(-3.637 -3)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8769",
                "data-name": "Path 8769",
                d: "M4.692,16a1.054,1.054,0,0,1,1.056,1.053v2.105a1.051,1.051,0,0,0,.309.744h0a1.057,1.057,0,0,0,.746.308H19.47a1.054,1.054,0,0,0,1.056-1.053V17.053a1.056,1.056,0,0,1,2.111,0v2.105a3.162,3.162,0,0,1-3.167,3.158H6.8a3.162,3.162,0,0,1-3.167-3.158V17.053A1.054,1.054,0,0,1,4.692,16Z",
                transform: "translate(0 0.684)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8770",
                "data-name": "Path 8770",
                d: "M6.946,10.308a1.058,1.058,0,0,1,1.493,0l4.531,4.519L17.5,10.308A1.054,1.054,0,0,1,18.994,11.8L13.716,17.06a1.058,1.058,0,0,1-1.493,0L6.946,11.8A1.051,1.051,0,0,1,6.946,10.308Z",
                transform: "translate(0.167 0.368)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8771",
                "data-name": "Path 8771",
                d: "M12.692,3a1.054,1.054,0,0,1,1.056,1.053V16.684a1.056,1.056,0,0,1-2.111,0V4.053A1.054,1.054,0,0,1,12.692,3Z",
                transform: "translate(0.444)",
                fill: "#fff",
                fillRule: "evenodd"
              })]
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "login_2",
              "data-name": "login 2",
              transform: "translate(-3.25)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8718",
                "data-name": "Path 8718",
                d: "M12.107,3.25a.857.857,0,1,0,0,1.714,8.286,8.286,0,0,1,0,16.571.857.857,0,1,0,0,1.714,10,10,0,0,0,0-20Z",
                transform: "translate(1.143 -3.25)",
                fill: "#fff"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8719",
                "data-name": "Path 8719",
                d: "M11.5,9.713A.857.857,0,1,1,12.713,8.5l3.429,3.429a.857.857,0,0,1,0,1.212L12.713,16.57A.857.857,0,1,1,11.5,15.358l1.965-1.965H4.107a.857.857,0,0,1,0-1.714h9.359Z",
                transform: "translate(0 -2.536)",
                fill: "#fff"
              })]
            })
          }) : '', text]
        })
      })
    })
  });
};

var StyledBtn = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Button__StyledBtn",
  componentId: "sc-1qz5gh2-0"
})(["&.dc-btn{margin:", ";width:", ";height:", "px;cursor:pointer;a{display:flex;width:", ";height:100%;align-items:center;justify-content:center;font-size:", "px;font-weight:", ";margin:0;line-height:", "px;background-color:", ";position:relative;border-radius:", "px;overflow:hidden;z-index:0;transition:border 1s cubic-bezier(.25,.74,.22,.99);padding:", ";box-sizing:border-box;border:", ";border-color:", ";border-style:", ";span{transition:all 1s cubic-bezier(.25,.74,.22,.99);color:", ";position:relative;z-index:2;top:2px;line-height:45px;svg{margin-right:8px;line{transition:all 1s cubic-bezier(.25,.74,.22,.99);}path{transition:all 1s cubic-bezier(.25,.74,.22,.99);}}}&:before{bottom:0;content:\"\";display:block;position:absolute;right:0;top:0;left:0;background-color:", ";height:100%;width:100%;margin:auto;transition:all 1s cubic-bezier(.25,.74,.22,.99);border-radius:22px;transform:translateY(100px);}&:hover{span{color:", ";}svg{line{stroke:", ";}path{fill:", ";}}&:before{transform:translate(0);}}&:focus{color:#222222;}}}"], function (props) {
  return props.margin || '0';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.height || '44';
}, function (props) {
  return props.width || 'fit-content';
}, function (props) {
  return props.fontSize || '16';
}, function (props) {
  return props.fontWeight || 500;
}, function (props) {
  return props.lineHeight || '24';
}, function (props) {
  return props.background || "#978C21";
}, function (props) {
  return props.borderRadius || '22';
}, function (props) {
  return props.padding || "0px 36px";
}, function (props) {
  return props.border || "none";
}, function (props) {
  return props.borderColor || "transparent";
}, function (props) {
  return props.border ? 'solid' : "transparent";
}, function (props) {
  return props.color || "#FFFFFF";
}, function (p) {
  return p.hoverBackground || '#3C3C3B';
}, function (props) {
  return props.hoverColor || "#FFF";
}, function (props) {
  return props.hoverColor || '#FFF';
}, function (props) {
  return props.hoverColor || '#FFF';
});
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Button));

/***/ }),

/***/ 68019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var nolazy = _ref.nolazy,
      visible = _ref.visible,
      srcSm = _ref.srcSm,
      src = _ref.src,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  var DefaultBanner = '/images/static/blurbg.svg';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      deviceWidth = _useState[0],
      setDeviceWidth = _useState[1]; // set device width


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function HandleWidth() {
      setDeviceWidth(window.innerWidth);
    }

    window.addEventListener('resize', HandleWidth);
    HandleWidth();
    return function () {
      window.removeEventListener('resize', HandleWidth);
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image",
    srcSm: srcSm,
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      alt: alt || 'Shanta Securities Limited',
      objectFit: 'cover',
      layout: 'fill',
      src: src ? deviceWidth > 600 ? src : srcSm ? srcSm : src : DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Img__StyledImg",
  componentId: "sc-1091rec-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";img{width:100%;height:100%;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 98508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68777);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var Img = function Img(_ref) {
  var src = _ref.src,
      visible = _ref.visible,
      speed = _ref.speed,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  // const smoother = useContext(SmootherContext);
  //
  // useEffect(() => {
  //     smoother.effects("img", {speed: "auto"})
  // }, [])
  var DefaultBanner = '/images/static/blurbg.svg';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledImg, {
    className: "global-image  ",
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      placeholder: "blur",
      objectFit: 'cover',
      layout: 'fill',
      alt: alt || 'Shanta Securities Limited',
      src: src || DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ImgP__StyledImg",
  componentId: "sc-ncc5rv-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";overflow:hidden;img{width:100%;height:130%;object-fit:", ";position:absolute;top:-50px;left:0;right:0;bottom:0;will-change:transform;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 93264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68312);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Title = function Title(_ref) {
  var text = _ref.text,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      color = _ref.color,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      textTransform = _ref.textTransform,
      margin = _ref.margin,
      padding = _ref.padding,
      borderColor = _ref.borderColor,
      varient = _ref.varient,
      center = _ref.center,
      classname = _ref.classname,
      small_text = _ref.small_text,
      noanim = _ref.noanim,
      h1 = _ref.h1;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledTitle, {
    className: "title fade-up ".concat(classname),
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    lineHeight: lineHeight,
    LetterSpacing: letterSpacing,
    textTransform: textTransform,
    margin: margin,
    padding: padding,
    varient: varient,
    center: center,
    borderColor: borderColor,
    children: text ? h1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("h1", {
      className: "".concat(noanim ? '' : 'split-up'),
      children: [" ", (0,react_html_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(text), " "]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("h2", {
      className: "".concat(noanim ? '' : 'split-up'),
      children: [" ", (0,react_html_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(text), " "]
    }) : ''
  });
};

var StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-n2utlk-0"
})(["margin:", ";position:relative;width:100%;font-family:", ";text-align:", ";padding:", ";h2{font-family:", ";font-size:", "px;line-height:", "px;letter-spacing:-1px;font-weight:", ";color:", ";span{color:", ";}}h1{font-family:", ";font-size:", "px !important;line-height:", "px !important;letter-spacing:-1px !important;font-weight:", " !important;color:", " !important;span{color:", " !important;}}@media (max-width:767px){margin-bottom:40px;padding:0;h2{font-size:35px !important;line-height:42px !important;sub{bottom:9.1px;line-height:inherit;}}h1{font-size:35px !important;line-height:42px !important;sub{bottom:9.1px;line-height:inherit;}}}"], function (props) {
  return props.margin || '0px';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .title */ .TN, function (props) {
  return props !== null && props !== void 0 && props.center ? 'center' : '';
}, function (p) {
  return p.padding;
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .title */ .TN, function (props) {
  return props.fontSize || 44;
}, function (props) {
  return props.lineHeight || 56;
}, function (props) {
  return props.fontWeight || '500';
}, function (props) {
  return props.color || '#3C3C3B';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .title */ .TN, function (props) {
  return props.fontSize || 44;
}, function (props) {
  return props.lineHeight || 56;
}, function (props) {
  return props.fontWeight || '500';
}, function (props) {
  return props.color || '#3C3C3B';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Title));

/***/ }),

/***/ 8711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ImgP__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98508);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var InnerbannerV9 = function InnerbannerV9(_ref) {
  var full = _ref.full,
      title = _ref.title,
      text = _ref.text,
      project = _ref.project,
      id = _ref.id,
      src = _ref.src,
      vh = _ref.vh,
      data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledInnerBanner, {
    id: "".concat(id ? id : 'InnerBanner'),
    full: full,
    vh: vh,
    className: "InnerBanner ".concat(project ? 'project_banner' : ''),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "InnerBanner__parallax",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "blur_image parallax",
        children: [src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ImgP__WEBPACK_IMPORTED_MODULE_0__/* .Img */ .E, {
          src: src,
          alt: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
              className: "flex_box ",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                md: 7,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  className: "title",
                  children: title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h1", {
                    "data-lag": '0.4',
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(title)
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                md: 5,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  className: "text",
                  children: text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
                    "data-lag": '0.4',
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(text)
                  })
                })
              })]
            })
          })
        })]
      })
    })
  });
};

var StyledInnerBanner = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "innerbanner-v9__StyledInnerBanner",
  componentId: "sc-1lkjrda-0"
})(["position:relative;.InnerBanner__parallax{padding-top:", ";position:relative;@media (min-width:1550px){padding-top:", ";}@media (max-width:767px){padding-top:", ";}.flex_box{display:flex;justify-content:space-between;align-items:flex-end;width:100%;@media (max-width:767px){flex-direction:column;text-align:left;align-items:flex-start;}.text{position:relative;z-index:2;display:flex;justify-content:flex-end;@media (max-width:767px){display:block;justify-content:unset;}p{font-size:16px;font-weight:500;line-height:24px;color:#FFFFFF;@media (max-width:767px){text-align:left;br{}}}}}.blur_image{width:100%;height:100%;position:absolute;left:0;right:0;bottom:0;}.container{position:absolute;margin:0 auto;z-index:2;bottom:100px;left:0;right:0;@media (max-width:767px){bottom:40px;}h1{z-index:2;font-size:44px;line-height:56px;letter-spacing:-1px;margin:30px 0 0;font-weight:500;color:#FFFFFF;font-family:'Avenir';@media (max-width:767px){font-size:36px;line-height:42px;margin-bottom:15px;}}}}@media (min-width:1550px){}@media (max-width:767px){.InnerBanner__parallax{padding-top:", ";.container{bottom:40px;h1{font-size:40px;line-height:40px;margin:0px 0 20px;}}.flex_box{flex-direction:column;text-align:left;align-items:flex-start;.title{width:100%;}.text{display:block;justify-content:unset;p{width:100%;text-align:left;br{}}}}}}"], function (props) {
  return props.full ? '100vh' : 'calc(560 / 1366 * 100%)';
}, function (props) {
  return props.full ? '100vh' : 'calc(560 / 1366 * 100%)';
}, function (props) {
  return props.full ? '100vh' : 'calc(560 / 375 * 100%)';
}, function (props) {
  return props.full ? '100vh' : '70vh';
});
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(InnerbannerV9));

/***/ }),

/***/ 11267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ApiParamKey; }
/* harmony export */ });
var ApiParamKey = {
  TYPE: 'type',
  PAGE_ID: 'page_id',
  PAGE_SLUG: 'page_slug',
  VALUE: 'value',
  GET_SECTION: 'get_section',
  IMAGE: 'image',
  POST: 'post',
  FILE: 'file',
  GALLERY: 'gallery',
  LIMIT: 'limit',
  VARIATION: 'variation',
  SPECIFICATION: 'specification',
  KEYWORD: 'keyword',
  PARENTPAGE: 'parent_page_id',
  DIVISION_ID: 'division_id',
  RADIUS: 'radius',
  KEY: 'key',
  CATEGORY_ID: 'category_id',
  DATE: 'date',
  FILTER: 'filter',
  TIME: 'timestamp',
  STARTDATE: 'start_date',
  ENDDATE: 'end_date'
};

/***/ }),

/***/ 92495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ ApiServices; }
/* harmony export */ });
var ApiServices = {
  POSTS: 'get-req-data/posts',
  PHOTOS: 'get-req-data/photos',
  PAGE_DATA: 'get-req-data/page-data',
  SECTIONS: 'get-req-data/sections',
  SERVICERESEARCH: 'get-req-data/research-documents-all',
  JOB: 'get-req-data/job-list',
  TEAM: 'get-req-data/team-list',
  CHILD_PAGE: 'get-req-data/child-pages',
  PAGE_POST_DATA: 'get-req-data/page-post-data',
  SEARCH: 'get-req-data/search',
  SEARCHCAMPAIGN: 'get-req-data/campaign-search',
  ALL_CATEGORY: 'get-req-data/all-category',
  CHILD_CATEGORY: 'get-req-data/child-category',
  PRODUCT_DATA: 'get-req-data/product-data',
  ALL_PRODUCTS: 'get-req-data/all-products',
  POST_FORM: 'post-req-data/form-submit',
  // POST_FORM: 'form-fields?form_id=contact-form',
  // SERVICE_FORM: 'get-req-data/form-fields?form_id=our-services-form',
  SERVICE_FORM: 'post-req-data/form-submit',
  // GETINTOUCH_FORM: 'get-req-data/form-fields?form_id=get-in-touch',
  GETINTOUCH_FORM: 'post-req-data/form-submit',
  FIND_DEALER: 'get-req-data/dealer-location',
  // GOOGLE_PLACE_NEARBY:"place/nearbysearch/json"
  SETTINGS: 'get-req-data/settings-data',
  COURSEDATA: 'get-req-data/course-data',
  BlogData: 'get-req-data/blog-data',
  RESEARCHLIST: 'get-req-data/research-list',
  ADDSUBSCRIP: 'post-req-data/add-subscriber',
  SUBMITFORM: 'post-req-data/form-submit',
  INVESTOR: 'get-req-data/investor-data',
  REARCHLISTCAT: 'get-req-data/research-documents',
  BLOGCATEGORY: 'get-req-data/blog-list?category_id=21',
  HOMEJSON: 'json-data/home'
};

/***/ }),

/***/ 56657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_contact; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./pages/api/network/ApiServices.js
var ApiServices = __webpack_require__(92495);
// EXTERNAL MODULE: ./pages/api/network/ApiParamKey.js
var ApiParamKey = __webpack_require__(11267);
// EXTERNAL MODULE: ./pages/api/store/index.js + 9 modules
var store = __webpack_require__(38584);
// EXTERNAL MODULE: ./pages/api/redux/contact/index.js
var contact = __webpack_require__(86221);
// EXTERNAL MODULE: ./components/innerbanner-v9.jsx
var innerbanner_v9 = __webpack_require__(8711);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(21608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tab.js + 1 modules
var Tab = __webpack_require__(73192);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tabs.js + 20 modules
var Tabs = __webpack_require__(66473);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 51 modules
var react_select_esm = __webpack_require__(87118);
// EXTERNAL MODULE: ./components/Img.jsx
var Img = __webpack_require__(68019);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/contacts/AddressTab.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var MyComponent = function MyComponent(_ref) {
  var _data$posts;

  var data = _ref.data,
      id = _ref.id,
      offset = _ref.offset;
  var section_data = data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts.list;

  var _useState = (0,react.useState)('tab_0'),
      key = _useState[0],
      setKey = _useState[1];

  var customStyles = {
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        borderRadius: 0,
        color: state.isSelected ? '#FFF' : '#221F1F',
        backgroundColor: state.isSelected ? '#191818' : '#FFF',
        margin: 0,
        fontSize: 12,
        cursor: 'pointer',
        paddingLeft: 25
      });
    },
    menu: function menu(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: '#FFF',
        backgroundColor: state.isSelected ? '#191818' : '#978C21',
        margin: 0,
        borderRadius: 5,
        fontSize: 12
      });
    },
    menuList: function menuList(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        backgroundColor: state.isSelected ? '#C4C4C4' : '#FFF',
        borderRadius: 0,
        fontWeight: '600',
        color: '#FFF',
        fontSize: 12
      });
    }
  };

  var _useState2 = (0,react.useState)(''),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var handleChange = function handleChange(event) {
    setSelected(event.value); // 80

    document.querySelector('#controlled-tab-example-tab-tab' + event.value).click();
  }; // const options = [
  //     {value: 'tab_0', label: 'Head Office'},
  //     {value: 'tab_1', label: 'Uttara Branch'},
  //     {value: 'tab_2', label: 'Dilkusha Branch'},
  //     {value: 'tab_3', label: 'Chittagong Branch'},
  //     {value: 'tab_4', label: 'Digital Booth, Motijheel'},
  //
  // ];


  var options = section_data && section_data.length > 0 ? section_data.map(function (e, index) {
    var _e$data;

    return {
      value: "tab_".concat(index),
      label: e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.title // Assuming you have a 'branchName' field in each object

    };
  }) : [];

  var handleResearch = function handleResearch(selectedOption) {
    setKey(selectedOption);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledComponent, {
    getoffset: offset,
    id: "".concat(id ? id : 'AddressTab'),
    offset: offset,
    className: "addresstab ",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      fluid: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "tab_container",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
            md: 12,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "formobile",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                placeholder: 'Select Location',
                onChange: function onChange(e) {
                  return handleResearch(e.value);
                },
                styles: {
                  dropdownIndicator: function dropdownIndicator(provided, state) {
                    return _objectSpread(_objectSpread({}, provided), {}, {
                      transform: state.selectProps.menuIsOpen && "rotate(180deg)"
                    });
                  }
                },
                classNamePrefix: 'react-select',
                className: 'form-select',
                options: options,
                isSearchable: false,
                theme: function theme(_theme) {
                  return _objectSpread(_objectSpread({}, _theme), {}, {
                    borderRadius: 0,
                    colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
                      primary25: '#e9e9e9',
                      primary: 'black'
                    })
                  });
                }
              })
            }), section_data && (section_data === null || section_data === void 0 ? void 0 : section_data.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs/* default */.Z, {
              id: "controlled-tab-example",
              activeKey: key,
              onSelect: function onSelect(k) {
                return setKey(k);
              },
              children: section_data && (section_data === null || section_data === void 0 ? void 0 : section_data.length) > 0 && (section_data === null || section_data === void 0 ? void 0 : section_data.map(function (e, index) {
                var _e$data2, _e$data3, _e$data4, _e$data5, _e$data6, _e$data7, _e$data8, _e$data9, _e$data10, _e$data11, _e$data12, _e$data13, _e$data14, _e$data15, _e$images, _e$images$, _e$data16, _e$data17, _e$images2, _e$images2$;

                return /*#__PURE__*/(0,jsx_runtime.jsxs)(Tab/* default */.Z, {
                  eventKey: "tab_".concat(index),
                  title: e !== null && e !== void 0 && (_e$data2 = e.data) !== null && _e$data2 !== void 0 && _e$data2.title ? e === null || e === void 0 ? void 0 : (_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.title : '',
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "custom_pad row m-0",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
                      md: 3,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "Visit"
                      }), (e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.short_desc) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        href: e !== null && e !== void 0 && (_e$data5 = e.data) !== null && _e$data5 !== void 0 && _e$data5.map_url ? e === null || e === void 0 ? void 0 : (_e$data6 = e.data) === null || _e$data6 === void 0 ? void 0 : _e$data6.map_url : '',
                        target: '_blank',
                        children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : (_e$data7 = e.data) === null || _e$data7 === void 0 ? void 0 : _e$data7.short_desc)
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
                      md: 3,
                      className: 'email-col',
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "Email"
                      }), (e === null || e === void 0 ? void 0 : (_e$data8 = e.data) === null || _e$data8 === void 0 ? void 0 : _e$data8.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        href: "mailto:".concat(e === null || e === void 0 ? void 0 : (_e$data9 = e.data) === null || _e$data9 === void 0 ? void 0 : _e$data9.subtitle),
                        children: e === null || e === void 0 ? void 0 : (_e$data10 = e.data) === null || _e$data10 === void 0 ? void 0 : _e$data10.subtitle
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
                      md: {
                        span: 3
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "Phone"
                      }), (e === null || e === void 0 ? void 0 : (_e$data11 = e.data) === null || _e$data11 === void 0 ? void 0 : _e$data11.description) && (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : (_e$data12 = e.data) === null || _e$data12 === void 0 ? void 0 : _e$data12.description)]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
                      md: 3,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "Fax"
                      }), (e === null || e === void 0 ? void 0 : (_e$data13 = e.data) === null || _e$data13 === void 0 ? void 0 : _e$data13.extra_field) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        href: "tel:".concat(e === null || e === void 0 ? void 0 : (_e$data14 = e.data) === null || _e$data14 === void 0 ? void 0 : _e$data14.extra_field),
                        children: e === null || e === void 0 ? void 0 : (_e$data15 = e.data) === null || _e$data15 === void 0 ? void 0 : _e$data15.extra_field
                      })]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "clearfix"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                      md: 12,
                      className: 'google_map',
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: 'map_img',
                        children: (e === null || e === void 0 ? void 0 : (_e$images = e.images) === null || _e$images === void 0 ? void 0 : (_e$images$ = _e$images[0]) === null || _e$images$ === void 0 ? void 0 : _e$images$.full_path) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          target: '_blank',
                          href: e !== null && e !== void 0 && (_e$data16 = e.data) !== null && _e$data16 !== void 0 && _e$data16.map_url ? e === null || e === void 0 ? void 0 : (_e$data17 = e.data) === null || _e$data17 === void 0 ? void 0 : _e$data17.map_url : '/',
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                            alt: 'Shanta Securities Limited',
                            src: e === null || e === void 0 ? void 0 : (_e$images2 = e.images) === null || _e$images2 === void 0 ? void 0 : (_e$images2$ = _e$images2[0]) === null || _e$images2$ === void 0 ? void 0 : _e$images2$.full_path
                          })
                        })
                      })
                    })]
                  })]
                });
              }))
            })]
          })
        })
      })
    })
  });
};

var StyledComponent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "AddressTab__StyledComponent",
  componentId: "sc-a50j69-0"
})(["position:relative;padding-top:80px;background:#F2F2F2;.email-col{padding-left:45px;}@media (max-width:992px){overflow:hidden;}@media (max-width:767px){.google_map{padding:0;}}.hotline{img{height:50px;}}.map_img{position:relative;padding-top:calc(560 / 1268 * 100%);iframe{position:absolute;left:0;right:0;bottom:0;top:0;height:100%;width:100%;}}.formobile{display:none;@media (max-width:767px){display:block;margin:0;padding:0;}}&:after{height:40vh;position:absolute;left:0;right:0;bottom:0;background:#FFF;width:100%;z-index:1;content:\"\";@media (max-width:767px){display:none;height:calc(100vh + 10px);}}.container-fluid{position:relative;z-index:2;margin:0;width:100%;max-width:100%;padding-right:", ";padding-left:0;.google_map{padding-right:0;}@media (max-width:767px){padding:0 15px !important;}}.custom_pad{padding-left:", ";}.tab_container{width:100%;.nav-tabs{border:none;padding-left:", ";@media (max-width:767px){display:none;}.nav-item{border:none;margin-right:20px;&:last-child{margin-right:0;}.nav-link{border:1px solid rgba(60,60,59,0.5);height:45px;font-size:16px;font-weight:500;color:#3C3C3B;background:transparent;border-radius:25px;padding:0 30px;line-height:45px;position:relative;transition:0.8s all cubic-bezier(0.4,0,0,1);font-family:'Avenir';overflow:hidden;&:after{position:absolute;left:0;right:0;top:0;bottom:0;background:#978C21;content:\"\";border-radius:25px;transition:0.8s all cubic-bezier(0.4,0,0,1);transform:translateY(150%);z-index:-1;}&:hover{color:#FFFFFF;&:after{transform:translateY(0);}}&.active{color:#FFFFFF;background:transparent;&:after{transform:translateY(0);}}}}}.google_map{margin-top:80px;}.tab-pane{padding-top:80px;@media (max-width:767px){padding-top:40px;.col-md-3,.col-md-4,.col-md-2{margin-bottom:40px;}.col-md-3:last-child{margin:0;}}p,a{color:#3C3C3B;font-size:16px;font-weight:500;line-height:24px;line-height:20px;display:block;margin-bottom:10px;&:last-child{margin-bottom:0;}}span{display:block;color:rgba(60,60,59,0.5);font-size:16px;font-weight:500;line-height:24px;margin:0 0 10px 0;}}}.react-select__control{border:none !important;height:45px;background:#978c21;box-shadow:none !important;border-radius:30px;.react-select__control--menu-is-open{box-shadow:none !important;.react-select__indicator{padding-right:15px;}}.react-select__value-container{padding:3px 25px 0;}.react-select__indicator{padding:0px 15px;svg{path{fill:white;stroke-width:0;}}}.react-select__indicator-separator{display:none;}.react-select__single-value{font-family:'Avenir' !important;font-size:16px !important;font-weight:500 !important;line-height:24px !important;color:#FFFFFF !important;}.select__single-value,.react-select__placeholder{font-family:'Avenir' !important;font-size:16px !important;font-weight:500 !important;line-height:24px !important;color:#FFFFFF !important;}.react-select__input-container{.react-select__input{font-family:'Avenir' !important;font-size:16px !important;font-weight:500 !important;line-height:24px !important;color:#FFFFFF !important;}}}@media (max-width:993px){.nav-tabs{padding-left:60px !important;gap:30px;}.custom_pad{padding-left:60px;> div{max-width:50%;}}}@media (max-width:993px){.nav-tabs{padding-left:15px !important;gap:30px;}.custom_pad{padding-left:0px;> div{padding-left:0px;padding-right:0px;max-width:100%;}}}"], function (props) {
  return props.getoffset ? props.getoffset + 'px' : '';
}, function (props) {
  return props.getoffset ? props.getoffset - 15 + 'px' : '';
}, function (props) {
  return props.getoffset ? props.getoffset + 'px' : '';
});
/* harmony default export */ var AddressTab = (MyComponent);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 14 modules
var Form = __webpack_require__(97346);
// EXTERNAL MODULE: ./components/Button.jsx
var Button = __webpack_require__(36981);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./components/contacts/ListWithForm.jsx




function ListWithForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ListWithForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ListWithForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ListWithForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var ListWithForm = function ListWithForm(_ref) {
  var _data$images, _data$images2, _data$images2$list, _data$images3, _data$images3$list, _errors$name, _formState$errors, _formState$errors$nam, _formState$errors2, _formState$errors2$na, _errors$email, _formState$errors3, _formState$errors3$em, _formState$errors4, _formState$errors4$em, _errors$phone, _formState$errors5, _formState$errors5$ph, _formState$errors6, _formState$errors6$ph, _formState$errors7, _formState$errors7$me, _formState$errors8, _formState$errors8$me;

  var padding = _ref.padding,
      data = _ref.data,
      id = _ref.id;

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'all'
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      formState = _useForm.formState,
      reset = _useForm.reset;

  var errors = formState.errors,
      isSubmitSuccessful = formState.isSubmitSuccessful;
  var store = (0,es/* useSelector */.v9)(function (state) {
    return state.home;
  }); //--- form submit

  var customStyles = {
    option: function option(provided, state) {
      return ListWithForm_objectSpread(ListWithForm_objectSpread({}, provided), {}, {
        borderRadius: 0,
        color: state.isSelected ? '#FFF' : 'rgba(0,0,0,0.5)',
        backgroundColor: state.isSelected ? '#00A651' : '#]212158',
        margin: 0,
        cursor: 'pointer'
      });
    },
    menu: function menu(provided, state) {
      return ListWithForm_objectSpread(ListWithForm_objectSpread({}, provided), {}, {
        color: 'rgba(0,0,0,0.5)',
        backgroundColor: state.isSelected ? 'rgba(0,0,0,0)' : 'rgba(255,255,255,0)',
        margin: 0
      });
    },
    menuList: function menuList(provided, state) {
      return ListWithForm_objectSpread(ListWithForm_objectSpread({}, provided), {}, {
        backgroundColor: state.isSelected ? '#000' : '#FFF',
        borderRadius: 0,
        cursor: 'pointer'
      });
    }
  }; //--- form submit

  var success = function success(msg) {
    return react_toastify_esm/* toast.success */.Am.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var error = function error(msg) {
    return react_toastify_esm/* toast.error */.Am.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var dispatch = (0,es/* useDispatch */.I0)();

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      var api_services, formData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api_services = ApiServices/* ApiServices.SUBMITFORM */.u.SUBMITFORM;
              formData = new FormData();
              formData.append('name', e === null || e === void 0 ? void 0 : e.name);
              formData.append('email', e === null || e === void 0 ? void 0 : e.email);
              formData.append('phone', e === null || e === void 0 ? void 0 : e.phone);
              formData.append('message', e === null || e === void 0 ? void 0 : e.message);
              formData.append('form_id', 'contact-form');

              if (!(e.email !== '' && e.name !== '' && e.phone !== '')) {
                _context.next = 10;
                break;
              }

              _context.next = 10;
              return dispatch((0,contact/* postForm */.Md)([api_services, formData]));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (!(store !== null && store !== void 0 && store.loading)) {
      if (isSubmitSuccessful) {
        success("Thank you for your message");
        reset();
      }
    }
  }, [isSubmitSuccessful, store]);
  var count = 0;

  var onError = function onError(errors) {
    Object.values(errors).forEach(function (error) {
      count++;
    });

    if (count > 0) {
      react_toastify_esm/* toast.error */.Am.error("Please fill out the correct inputs");
    }

    count = 0;
  }; // let count = 0;
  // const onError = (errors) => {
  //     Object.values(errors).forEach((error) => {
  //         count++;
  //     });
  //     if (count > 0) {
  //         toast.error('Please fill out the correct inputs');
  //     }
  //     count = 0;
  // };
  // useEffect(() => {
  //     if (responseData && responseData?.error !== '') {
  //         error(responseData?.error?.message)
  //     }
  //     if (responseData && responseData?.success !== '') {
  //         success(responseData?.success)
  //
  //     }
  //     reset();
  //
  // }, [responseData])


  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledListWithForm, {
    id: "".concat(id ? id : 'ListWithForm'),
    className: "list_with_form ".concat(padding ? padding : 'pt-200 ', " "),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          md: 6,
          className: 'left-col',
          children: (data === null || data === void 0 ? void 0 : (_data$images = data.images) === null || _data$images === void 0 ? void 0 : _data$images.list) && (data === null || data === void 0 ? void 0 : (_data$images2 = data.images) === null || _data$images2 === void 0 ? void 0 : (_data$images2$list = _data$images2.list) === null || _data$images2$list === void 0 ? void 0 : _data$images2$list.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$images3 = data.images) === null || _data$images3 === void 0 ? void 0 : (_data$images3$list = _data$images3.list) === null || _data$images3$list === void 0 ? void 0 : _data$images3$list.map(function (e, index) {
            if ((e === null || e === void 0 ? void 0 : e.thumb) === 'on') {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "image-wrapper",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                  alt: 'Shanta Securities Limited',
                  src: e === null || e === void 0 ? void 0 : e.full_path
                })
              });
            }
          }))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          className: 'right_col',
          md: {
            span: 6
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "form_wrapper",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default */.Z, {
              className: 'form',
              onSubmit: handleSubmit(onSubmit, onError),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                name: 'spam_protector',
                type: "hidden"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                name: 'form_id',
                value: 'contact-form',
                type: "hidden"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "form-group",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                  controlId: "formBasicEmail",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, ListWithForm_objectSpread(ListWithForm_objectSpread({
                    className: errors !== null && errors !== void 0 && (_errors$name = errors.name) !== null && _errors$name !== void 0 && _errors$name.message ? 'has-error form-control-lg' : 'form-control-lg'
                  }, register("name", {
                    required: 'Name is required'
                  })), {}, {
                    type: "text",
                    placeholder: "Name*"
                  })), (formState === null || formState === void 0 ? void 0 : (_formState$errors = formState.errors) === null || _formState$errors === void 0 ? void 0 : (_formState$errors$nam = _formState$errors.name) === null || _formState$errors$nam === void 0 ? void 0 : _formState$errors$nam.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "error-message form-error",
                    children: formState === null || formState === void 0 ? void 0 : (_formState$errors2 = formState.errors) === null || _formState$errors2 === void 0 ? void 0 : (_formState$errors2$na = _formState$errors2.name) === null || _formState$errors2$na === void 0 ? void 0 : _formState$errors2$na.message
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "form-group",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                  controlId: "formBasicEmail",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, ListWithForm_objectSpread(ListWithForm_objectSpread({
                    className: errors !== null && errors !== void 0 && (_errors$email = errors.email) !== null && _errors$email !== void 0 && _errors$email.message ? 'has-error form-control-lg' : 'form-control-lg'
                  }, register("email", {
                    required: {
                      value: true,
                      message: 'Please enter your email'
                    },
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Please enter a valid email address'
                    }
                  })), {}, {
                    type: "email",
                    placeholder: "Email*"
                  })), (formState === null || formState === void 0 ? void 0 : (_formState$errors3 = formState.errors) === null || _formState$errors3 === void 0 ? void 0 : (_formState$errors3$em = _formState$errors3.email) === null || _formState$errors3$em === void 0 ? void 0 : _formState$errors3$em.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "error-message form-error",
                    children: formState === null || formState === void 0 ? void 0 : (_formState$errors4 = formState.errors) === null || _formState$errors4 === void 0 ? void 0 : (_formState$errors4$em = _formState$errors4.email) === null || _formState$errors4$em === void 0 ? void 0 : _formState$errors4$em.message
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "form-group",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                  controlId: "formBasicPhone",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, ListWithForm_objectSpread(ListWithForm_objectSpread({
                    className: errors !== null && errors !== void 0 && (_errors$phone = errors.phone) !== null && _errors$phone !== void 0 && _errors$phone.message ? 'has-error form-control-lg' : 'form-control-lg'
                  }, register("phone", {
                    required: {
                      value: true,
                      message: 'Please enter your phone number'
                    },
                    pattern: {
                      value: /^01[0-9]{9}$/,
                      message: 'Please enter a valid 11-digit phone number'
                    }
                  })), {}, {
                    type: "number",
                    placeholder: "Phone Number*"
                  })), (formState === null || formState === void 0 ? void 0 : (_formState$errors5 = formState.errors) === null || _formState$errors5 === void 0 ? void 0 : (_formState$errors5$ph = _formState$errors5.phone) === null || _formState$errors5$ph === void 0 ? void 0 : _formState$errors5$ph.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "error-message form-error",
                    children: formState === null || formState === void 0 ? void 0 : (_formState$errors6 = formState.errors) === null || _formState$errors6 === void 0 ? void 0 : (_formState$errors6$ph = _formState$errors6.phone) === null || _formState$errors6$ph === void 0 ? void 0 : _formState$errors6$ph.message
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "form-group",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                  controlId: "formBasicPhone",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, ListWithForm_objectSpread(ListWithForm_objectSpread({}, register("message", {
                    required: {
                      // value:true,
                      message: 'Please enter your Message'
                    }
                  })), {}, {
                    type: "text",
                    placeholder: "Message (Optional)"
                  })), (formState === null || formState === void 0 ? void 0 : (_formState$errors7 = formState.errors) === null || _formState$errors7 === void 0 ? void 0 : (_formState$errors7$me = _formState$errors7.message) === null || _formState$errors7$me === void 0 ? void 0 : _formState$errors7$me.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "error-message form-error",
                    children: formState === null || formState === void 0 ? void 0 : (_formState$errors8 = formState.errors) === null || _formState$errors8 === void 0 ? void 0 : (_formState$errors8$me = _formState$errors8.message) === null || _formState$errors8$me === void 0 ? void 0 : _formState$errors8$me.message
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  width: 'fit-content'
                },
                className: "'form-group width-fit'}",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  onClick: handleSubmit(onSubmit, onError),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    hoverColor: '#3C3C3B',
                    hoverBackground: '#978C21',
                    color: '#fff',
                    text: 'Send Message'
                  })
                })
              })]
            })
          })
        })]
      })
    })
  });
};

var StyledListWithForm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ListWithForm__StyledListWithForm",
  componentId: "sc-1l8uqy5-0"
})(["background:#FFFFFF;.left-col{padding-right:55px;}@media(max-width:767px){overflow:hidden;.right_col{padding-right:0;}}.image-wrapper{position:relative;padding-top:calc(469 / 530 * 100%);height:100%;}.form_wrapper{background:#3C3C3B;padding:60px;height:100%;@media (min-width:1550px){}@media (max-width:992px) and (min-width:768px){padding:30px;}form{display:flex;height:100%;flex-direction:column;justify-content:space-between;}.title{font-size:24px;font-weight:4000;line-height:28px;color:#F9F9F9;margin:0 0 40px;}.form-group{margin-bottom:25px;&:last-child{margin-bottom:0;}.form-control{box-shadow:none;outline:0;border-radius:0;background:transparent;height:auto;border-left:none;border-right:none;border-top:none;border-color:rgba(255,255,255,0.5);padding:0 0 8px;color:#FFFFFF;font-size:16px;font-weight:500;line-height:24px;&::placeholder{color:rgba(255,255,255,0.5);font-size:14px;font-weight:400;line-height:20px;}}}.dc-btn{a{&:before{background:#fff;}span{color:#FFFFFF;}&:hover{span{color:#3C3C3B;}}}}.filter__placeholder{color:#C4C4C4;font-size:14px;font-weight:400;line-height:20px;}.filter__control{height:30px !important;padding:0 !important;background:transparent !important;border-left:none !important;border-right:none !important;border-top:none !important;border-color:rgba(246,246,247,0.2) !important;.filter__single-value{color:#C4C4C4 !important;font-size:14px !important;font-weight:400 !important;line-height:20px !important;}.filter__indicator-separator{display:none;}.filter__value-container{padding:0;}.filter__dropdown-indicator,.filter__input-container,.filter__placeholder{margin:0;}}}@media (max-width:767px){padding-top:0;padding-bottom:0;.form_wrapper{padding:60px 15px;margin-top:0px;}.left-col{padding-right:0px;}.container{padding:0;}}input:-webkit-autofill{-webkit-text-fill-color:#fff !important;}"]);
/* harmony default export */ var contacts_ListWithForm = (ListWithForm);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 9 modules
var Accordion = __webpack_require__(54076);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./components/Title.jsx
var Title = __webpack_require__(93264);
// EXTERNAL MODULE: ./styles/globalStyleVars.js
var globalStyleVars = __webpack_require__(68312);
;// CONCATENATED MODULE: ./components/contacts/Accordion-v2.jsx











var Faq = function Faq(_ref) {
  var _data$section_data, _data$section_data2, _data$posts;

  var data = _ref.data;
  var section_data = data !== null && data !== void 0 && (_data$section_data = data.section_data) !== null && _data$section_data !== void 0 && _data$section_data.subtitle ? data === null || data === void 0 ? void 0 : (_data$section_data2 = data.section_data) === null || _data$section_data2 === void 0 ? void 0 : _data$section_data2.subtitle : 'Frequently </br> Asked </br> Questions';
  var section_post = data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts.list;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFaq, {
    id: 'faq',
    className: "job-lists pt-160 ",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          sm: 4,
          className: "job-lists__sidebar",
          children: section_data && /*#__PURE__*/(0,jsx_runtime.jsx)(Title["default"], {
            noanim: true,
            margin: '0 0 40px 0',
            text: section_data
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          sm: 8,
          className: "job-lists__content",
          children: section_post && (section_post === null || section_post === void 0 ? void 0 : section_post.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* default */.Z, {
            defaultActiveKey: "0",
            children: section_post === null || section_post === void 0 ? void 0 : section_post.map(function (e, index) {
              var _e$data, _e$data2, _e$data3, _e$data4;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                eventKey: String(index),
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Accordion/* default.Header */.Z.Header, {
                  children: [(e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.title) && (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.title), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(bs_index_esm/* BsChevronDown */.IAR, {})
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* default.Body */.Z.Body, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: (e === null || e === void 0 ? void 0 : (_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.description) && (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.description)
                  })
                })]
              });
            })
          })
        })]
      })
    })
  });
};

var StyledFaq = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Accordion-v2__StyledFaq",
  componentId: "sc-jrpdcs-0"
})([".job-lists__sidebar{&__mobile-dropdown{@media (min-width:551px){display:none;}}p{font-size:32px;line-height:36px;font-weight:600;width:80%;}ul{@media (max-width:550px){display:none;}li{margin-bottom:10px;a{font-size:16px;font-weight:600;line-height:22px;position:relative;&:after{content:'';position:absolute;border-radius:50%;top:0;bottom:0;right:-15px;margin:auto;height:10px;width:10px;background-color:red;display:none;}}&.active{a{color:red;&:after{display:block;}}}}}}.accordion-item{margin-bottom:20px;}.accordion-header{position:relative;margin:0px;font-size:unset;line-height:unset;button{border:none;background-color:transparent;padding-left:0;color:#3C3C3B;font-size:24px;font-weight:500;line-height:32px;padding-bottom:15px;border-bottom:1px solid #3C3C3B;width:100%;font-family:", ";text-align:left;transition:all .4s ease;&.collapsed{color:#3C3C3B;border-color:#3C3C3B;span{background-color:#3C3C3B;svg{transform:rotate(0deg);}&:after{background-color:#3C3C3B !important;}}}}span{position:absolute;height:30px;width:30px;border-radius:50%;color:#ffffff;background-color:#978C21;right:0;display:flex;align-items:center;justify-content:center;bottom:16px;&:after{height:0;width:0;background-color:#978C21;border-radius:50%;opacity:0;transition:all .4s ease;content:'';position:absolute;}svg{font-size:13px;z-index:2;transform:rotate(180deg);}}&:hover{span{&:after{height:100%;width:100%;opacity:1;}}button{color:#978C21;border-color:#978C21;}}}.accordion-body{padding-bottom:20px;padding-top:40px;p{font-size:16px;line-height:24px;font-weight:500;color:#3C3C3B;}h6{font-size:20px;margin-bottom:10px;}ul,ol{li{padding-left:20px;position:relative;&:after{height:10px;width:10px;background:", ";content:'';position:absolute;left:0;top:5px;border-radius:50%;}}}}.css-yk16xz-control,.css-1pahdxg-control{border-radius:18px !important;border-color:#989898;height:40px;background-color:red;cursor:pointer;padding-left:15px;}.css-yk16xz-control .css-1wa3eu0-placeholder,.css-1pahdxg-control .css-1wa3eu0-placeholder,.css-1uccc91-singleValue{color:#ffffff !important;font-size:12px !important;font-weight:bold;cursor:pointer;}.css-yk16xz-control .css-tlfecz-indicatorContainer,.css-1pahdxg-control .css-tlfecz-indicatorContainer,.css-yk16xz-control .css-1gtu0rj-indicatorContainer,.css-1pahdxg-control .css-1gtu0rj-indicatorContainer{margin-right:20px;margin-top:2px;}@media (max-width:767px){.job-lists__sidebar{margin-bottom:50px;p{width:100%;}}}"], globalStyleVars/* title */.TN, globalStyleVars/* hover */.Mr);
/* harmony default export */ var Accordion_v2 = (Faq);
// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var react_loadable_lib = __webpack_require__(68356);
var lib_default = /*#__PURE__*/__webpack_require__.n(react_loadable_lib);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/gsap/index.js
var gsap = __webpack_require__(62642);
;// CONCATENATED MODULE: ./pages/contact/index.jsx




















var Feedback = lib_default()({
  loader: function loader() {
    return Promise.all(/* import() */[__webpack_require__.e(814), __webpack_require__.e(4863), __webpack_require__.e(6839)]).then(__webpack_require__.bind(__webpack_require__, 16946));
  },
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: "Loading..."
    });
  }
});

var Contact = function Contact(_ref) {
  var _getPost$posts, _getPost$posts$data, _getPost$posts2, _getPost$posts2$data, _getPost$posts2$data$, _getPost$posts3, _getPost$posts3$data, _getPost$posts3$data$, _getPost$posts4, _getPost$posts4$data, _getPost$posts4$data$, _getPost$posts5, _getPost$posts5$data, _getPost$posts5$data$, _banner$section_data, _banner$images, _banner$images$list, _banner$images$list$;

  var offset = _ref.offset;
  var getPost = (0,es/* useSelector */.v9)(function (state) {
    return state.contactReducer;
  });
  var page_data = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts = getPost.posts) === null || _getPost$posts === void 0 ? void 0 : (_getPost$posts$data = _getPost$posts.data) === null || _getPost$posts$data === void 0 ? void 0 : _getPost$posts$data.page_data;
  var banner = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts2 = getPost.posts) === null || _getPost$posts2 === void 0 ? void 0 : (_getPost$posts2$data = _getPost$posts2.data) === null || _getPost$posts2$data === void 0 ? void 0 : (_getPost$posts2$data$ = _getPost$posts2$data.sections) === null || _getPost$posts2$data$ === void 0 ? void 0 : _getPost$posts2$data$.find(function (f) {
    var _f$section_data;

    return (f === null || f === void 0 ? void 0 : (_f$section_data = f.section_data) === null || _f$section_data === void 0 ? void 0 : _f$section_data.slug) === 'banner-contact';
  });
  var address = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts3 = getPost.posts) === null || _getPost$posts3 === void 0 ? void 0 : (_getPost$posts3$data = _getPost$posts3.data) === null || _getPost$posts3$data === void 0 ? void 0 : (_getPost$posts3$data$ = _getPost$posts3$data.sections) === null || _getPost$posts3$data$ === void 0 ? void 0 : _getPost$posts3$data$.find(function (f) {
    var _f$section_data2;

    return (f === null || f === void 0 ? void 0 : (_f$section_data2 = f.section_data) === null || _f$section_data2 === void 0 ? void 0 : _f$section_data2.slug) === 'address';
  });
  var faq = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts4 = getPost.posts) === null || _getPost$posts4 === void 0 ? void 0 : (_getPost$posts4$data = _getPost$posts4.data) === null || _getPost$posts4$data === void 0 ? void 0 : (_getPost$posts4$data$ = _getPost$posts4$data.sections) === null || _getPost$posts4$data$ === void 0 ? void 0 : _getPost$posts4$data$.find(function (f) {
    var _f$section_data3;

    return (f === null || f === void 0 ? void 0 : (_f$section_data3 = f.section_data) === null || _f$section_data3 === void 0 ? void 0 : _f$section_data3.slug) === 'faq';
  });
  var feedback = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts5 = getPost.posts) === null || _getPost$posts5 === void 0 ? void 0 : (_getPost$posts5$data = _getPost$posts5.data) === null || _getPost$posts5$data === void 0 ? void 0 : (_getPost$posts5$data$ = _getPost$posts5$data.sections) === null || _getPost$posts5$data$ === void 0 ? void 0 : _getPost$posts5$data$.find(function (f) {
    var _f$section_data4;

    return (f === null || f === void 0 ? void 0 : (_f$section_data4 = f.section_data) === null || _f$section_data4 === void 0 ? void 0 : _f$section_data4.slug) === 'feedback-contact';
  }); // const elementRef = useRef(null);
  // useEffect(() => {
  //     const element = elementRef.current;
  //
  //     // Function to handle the scroll trigger animation
  //     const animateElement = () => {
  //         // Your animation logic here using gsap
  //         gsap.to(element, { opacity: 0, duration: 1 });
  //     };
  //
  //     // Initialize the ScrollTrigger
  //     ScrollTrigger.create({
  //         trigger: element,
  //         onEnter: animateElement,
  //     });
  //
  //     // Refresh ScrollTrigger when the height of the element changes
  //     const observer = new ResizeObserver(() => {
  //         ScrollTrigger.refresh();
  //     });
  //
  //     observer.observe(element);
  //
  //     // Cleanup
  //     return () => {
  //         observer.disconnect();
  //     };
  // }, []);
  // on page load go down

  (0,react.useEffect)(function () {
    // Check if running in a browser environment
    if (true) {
      var urlFragment = window.location.hash;
      var urlhas = urlFragment ? "#".concat(urlFragment) : null; // Prepend '#' if fragment

      if (urlhas) {
        setTimeout(function () {
          var targetElement = document.querySelector(urlhas);

          if (targetElement) {
            document.body.style.overflow = 'auto';
            var html = document.querySelector('html');
            html.style.overflow = 'auto';
            gsap/* default.to */.ZP.to(window, {
              duration: 1,
              scrollTo: {
                y: targetElement.offsetTop
              }
            });
          }
        }, 600);
      }
    }
  }, []); // useEffect(() => {
  //
  //     let split = gsap.utils.toArray(".split-up");
  //     gsap.registerPlugin(SplitText, CSSPlugin);
  //
  //
  //     if(window > 767){
  //
  //         gsap.utils.toArray('.split-up').forEach((item, i) => {
  //             const parentSplit = new SplitText(item, {
  //                 linesClass: "split-parent",
  //                 type: "lines",
  //             });
  //             const childSplit = new SplitText(item, {
  //                 type: "lines",
  //                 linesClass: "split-child"
  //             });
  //
  //             gsap.from(parentSplit.lines, {
  //                 duration: 1,
  //                 yPercent: 150,
  //                 ease: 'power4.out',
  //                 stagger: .08,
  //                 scrollTrigger: {
  //                     trigger: item,
  //                     toggleActions: "restart none none reset",
  //                     start: "top 98%",
  //                 }
  //             });
  //         });
  //
  //     }
  // }, [getPost])

  var router = (0,next_router.useRouter)();
  var currentUrl = router && router.asPath;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "".concat(page_data !== null && page_data !== void 0 && page_data.title ? (page_data === null || page_data === void 0 ? void 0 : page_data.title) + ' | Shanta Securities Limited' : 'Shanta Securities Limited'),
      description: page_data === null || page_data === void 0 ? void 0 : page_data.meta_description,
      canonical: "https://www.shantasecurities.com" + currentUrl,
      openGraph: {
        type: 'website',
        url: "https://www.shantasecurities.com" + currentUrl,
        title: page_data === null || page_data === void 0 ? void 0 : page_data.og_title,
        description: page_data === null || page_data === void 0 ? void 0 : page_data.og_description,
        images: [{
          url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }, {
          url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(innerbanner_v9/* default */.Z, {
      title: page_data === null || page_data === void 0 ? void 0 : page_data.title,
      text: banner === null || banner === void 0 ? void 0 : (_banner$section_data = banner.section_data) === null || _banner$section_data === void 0 ? void 0 : _banner$section_data.short_desc,
      src: banner === null || banner === void 0 ? void 0 : (_banner$images = banner.images) === null || _banner$images === void 0 ? void 0 : (_banner$images$list = _banner$images.list) === null || _banner$images$list === void 0 ? void 0 : (_banner$images$list$ = _banner$images$list[0]) === null || _banner$images$list$ === void 0 ? void 0 : _banner$images$list$.full_path
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "black",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AddressTab, {
        data: address,
        offset: offset
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(contacts_ListWithForm, {
        data: banner
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion_v2, {
        data: faq
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "feedback feedback_form_contact",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Feedback, {
          data: feedback,
          offset: offset
        })
      })]
    })]
  });
};

Contact.getInitialProps = store/* wrapper.getInitialPageProps */.YS.getInitialPageProps(function (store) {
  return /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _param;

    var api_services, param;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api_services = ApiServices/* ApiServices.SECTIONS */.u.SECTIONS;
            param = (_param = {}, (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, 'slug'), (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.VALUE */.j.VALUE, 'contact'), (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.GET_SECTION */.j.GET_SECTION, 'yes'), (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.IMAGE */.j.IMAGE, 'yes'), (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.POST */.j.POST, 'yes'), (0,defineProperty/* default */.Z)(_param, ApiParamKey/* ApiParamKey.GALLERY */.j.GALLERY, 'yes'), _param);
            _context.next = 4;
            return store.dispatch((0,contact/* fetchPosts */.T6)([api_services, param]));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
});
/* harmony default export */ var pages_contact = (Contact);

/***/ }),

/***/ 87803:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(56657);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,653,7724,7006,7346,7118,7536,3917,9774,2888,179], function() { return __webpack_exec__(87803); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);